// extracted by mini-css-extract-plugin
export default {"controls":"Slider_controls__Nf4eh","btn":"Slider_btn__hM+rj","btn_next":"Slider_btn_next__LV1ax"};